import { createSelectorByActionName } from '../utils/toolkit';

const reducerName = 'loadings';

export const createLoadingSelector = createSelectorByActionName(reducerName);
